import { Coordinate } from "ol/coordinate";
import RouterUrl from "./RouterUrl";

export default class RouterUrlWithExtent {
    constructor(routerUrl: RouterUrl) {
        this.routerUrl = routerUrl
        if(routerUrl.minLongitude > routerUrl.maxLongitude) {
            this.longitudeSpans = [[routerUrl.minLongitude, 180], [-180, routerUrl.maxLongitude]]
        }
        else {
            this.longitudeSpans = [[routerUrl.minLongitude, routerUrl.maxLongitude]]
        }
    }
    routerUrl: RouterUrl
    longitudeSpans: number[][]

    containsCoordinate(coord: Coordinate) {
        return this.longitudeSpans.some(span => coord[0] >= span[0] && coord[0] <= span[1])
    }
}